class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  // Con el menú en dos filas, llegar al panel de un ítem de la fila superior obliga a
  // cruzar la fila inferior. Si el cursor baja (va hacia el panel) se tolera ese
  // tránsito; si se mueve en horizontal, el cambio de ítem es casi inmediato.
  static SWITCH_DELAY = 120;
  static TRANSIT_DELAY = 700;
  static CLOSE_DELAY = 250;
  static current = null;

  // ¿Está este summary en una fila inferior a la del summary del panel abierto?
  static _isBelow(summary, openSummary) {
    return summary.getBoundingClientRect().top >= openSummary.getBoundingClientRect().bottom - 2;
  }

  _openMenu(summary) {
    this.mainDetailsToggle.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');
    HeaderMenu.current = this;
  }

  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this._closeTimer = null;

    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary && summary.dataset.url) {
      // Abrir al entrar con el cursor. Con el menú en dos filas, para llegar al panel
      // de un ítem de la fila superior el cursor cruza la fila inferior: si ya hay un
      // panel abierto, el cambio a otro ítem espera un instante (intención de hover)
      // y el panel actual sigue abierto durante el trayecto.
      this.addEventListener('mouseenter', () => {
        if (window.innerWidth < 990) return;
        if (this._closeTimer) {
          clearTimeout(this._closeTimer);
          this._closeTimer = null;
        }
        const current = HeaderMenu.current;
        const hasOtherOpen =
          current && current !== this && current.mainDetailsToggle.hasAttribute('open');
        if (!hasOtherOpen) {
          this._openMenu(summary);
          return;
        }
        clearTimeout(this._openTimer);
        this._openTimer = setTimeout(() => {
          this._openTimer = null;
          if (!this.matches(':hover')) return;
          current.close();
          this._openMenu(summary);
        }, HeaderMenu._isBelow(summary, current.mainDetailsToggle.querySelector('summary'))
          ? HeaderMenu.TRANSIT_DELAY
          : HeaderMenu.SWITCH_DELAY);
      });

      // Cerrar con delay — permite al cursor cruzar el gap entre trigger y panel
      // (y la fila inferior del menú cuando el panel es de la fila superior)
      this.addEventListener('mouseleave', (event) => {
        if (window.innerWidth < 990) return;
        clearTimeout(this._openTimer);
        this._openTimer = null;
        // Salida por debajo del ítem = va hacia el panel (o cruza la fila inferior)
        const exitedDown = event.clientY >= summary.getBoundingClientRect().bottom - 2;
        this._closeTimer = setTimeout(() => {
          // Solo cerrar si el cursor ya NO está dentro del elemento
          if (!this.matches(':hover') && !this.querySelector(':hover')) {
            this.close();
          }
          this._closeTimer = null;
        }, exitedDown ? HeaderMenu.TRANSIT_DELAY : HeaderMenu.CLOSE_DELAY);
      });

      // Click en el summary navega a la URL del ítem de nivel 1
      summary.addEventListener('click', (event) => {
        if (window.innerWidth >= 990) {
          event.preventDefault();
          event.stopPropagation();
          window.location.href = summary.dataset.url;
        }
      });
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

